/** Apply to {@link ModalType.PANE} when rendering a wizard inside a modal. */
export const wizardModalPaneClassName = 'wizard-modal-pane';

/** Layout classes for the wizard shell rendered inside a modal pane. */
export const wizardModalClassNames = {
    root: 'wizard-modal',
    header: 'wizard-modal-header border-border-default flex w-full min-w-0 flex-col gap-4 overflow-hidden border-b px-6 py-5',
    body: 'wizard-modal-body px-6 py-6',
    footer: 'wizard-modal-footer border-border-default flex w-full min-w-0 flex-wrap items-center justify-between gap-3 border-t px-6 py-4',
    loading: 'wizard-modal-loading'
} as const;
